module.exports = __webpack_public_path__ + "img/19_41.fade3fea.png";